import { defaultClient } from '@api/client';

export const editPost = ({ post: { ignore_whitespace, ...post } }) => {
  return defaultClient.patch(`/posts/${post.id}`, post);
};
